// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  

.chat-container {
    max-width: 600px;
    margin: auto;
    padding: 20px;
    text-align: center;
}

.chatbox {
    height: 500px;
    overflow-y: auto;
    padding: 10px;
    width: 80%;
}
.chatbox-conent-inner{
    display: flex;
    justify-content: center;
}
/* 
.message {
    padding: 10px;
    border-radius: 8px;
    margin: 5px 0;
} */

.user {
    /* background: #d1e7ff; */
    text-align: right;
}

.bot {
    /* background: #e5e5e5; */
    text-align: left;
}

.chat-input {
    display: flex;
    gap: 10px;
    margin-top: 10px;
}

.chat-input input {
    flex: 1 1;
    padding: 10px;
}

.chat-input button {
    padding: 10px 15px;
    background: blue;
    color: white;
    border: none;
}

.container {
    display: flex;
    height: 100vh; /* Full height */
  }
  
  .sidebar {
    width: 0%;
    background-color: #f4f4f4; /* Optional: Add a background color */
  }
  
  .chatbot {
    width: 70%;
    background-color: #fff; /* Optional */
  }
.home-inner-page .chatbox-conent-inner .chatbox {
    width: 100%;
    height: auto;
    overflow-y: hidden;

}
div.css-m39tm9 {
    background-color: unset;
}
/* .question-inner-part{
font-weight: 500;
font-size: 15px;
} */

.question-inner-part{
font-family: ui-sans-serif, -apple-system, system-ui, "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol";
font-weight: 500;
font-size: 17px;

}
.answer-inner-part{
font-family: ui-sans-serif, -apple-system, system-ui, "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol";

font-weight: 400;
font-size: 17px;
margin-bottom: 10px;
}

/* .message-inner{
  font-weight: 400;
  font-size: 15px;

} */

.message-inner {
  font-family: ui-sans-serif, -apple-system, system-ui, "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol";
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  color: rgb(13, 13, 13);
  line-height: 30px; /* Equal to 1.75 * font-size — good for readability */
}

/* .answer-inner-part{
font-weight: 400;
font-size: 15px;
margin-bottom: 10px;
} */
.group-image{
    margin-top: -25px;
}
.contents.full-unit:hover{
    background-color: LightGrey;
}
.generate-inner,
.contents.full-unit{
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 19px;
}
.sidebar-settings-icon {
    width: 18px;
    height: 18px;
    color: #2C68A1;
}
.spinner-box {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  flex-flow: column; 
  /* position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); */
  height:calc(100vh - 250px); /* full viewport height */

}
/* ===================================== New CSS for Chat Interface ===================================== */

/* Fixed Bottom Section - Button won't move */
.inner-images-content {
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  z-index: 100;
  padding: 15px 0px;
  /* box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); */
  border-top: 1px solid #e0e0e0;
}

/* Chat Container - Scrollable area */
.output-outer-content {
 /* padding-bottom: 220px;  Space for fixed bottom section */
  overflow-y: auto;
  /* max-height: calc(100vh - 250px); */
}

.chatbox {
  padding-bottom: 20px;
}

/* Input Field Container */
.input-field-btn {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.input-field {
  flex: 1 1;
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  resize: none;
  outline: none;
  font-family: inherit;
}

.input-field:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
}

.submit-btn {
  padding: 10px 20px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background 0.2s;
}

.submit-btn:hover {
  background: #0056b3;
}

.submit-btn:active {
  transform: scale(0.98);
}

.submit-btn img {
  width: 16px;
  height: 16px;
}

/* Bottom Buttons Container */
.buttons-cont-flex {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: left;
}

.buttons-cont-flex button {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  font-size: 14px;
}

.buttons-cont-flex button:hover {
  background: #f5f5f5;
  border-color: #007bff;
  transform: translateY(-1px);
}

.high-light-btn {
  background: #007bff !important;
  color: white !important;
  border-color: #007bff !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .inner-images-content {
    padding: 10px;
  }
  
  .output-outer-content {
    padding-bottom:25px;
  }
  
  .buttons-cont-flex {
    gap: 5px;
  }
  
  .buttons-cont-flex button {
    padding: 6px 12px;
    font-size: 12px;
  }
  
  .submit-btn {
    padding: 8px 16px;
  }
}

/* Smooth Scrolling */
.output-outer-content {
  scroll-behavior: smooth;
}

/* Optional: Hide scrollbar but keep functionality */
.output-outer-content::-webkit-scrollbar {
  width: 8px;
}

.output-outer-content::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.output-outer-content::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.output-outer-content::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Learning Supports: Autofill button pulse animation (theme blue #2c68a1) */
@keyframes learning-supports-autofill-pulse {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(44, 104, 161, 0.5);
    transform: scale(1);
  }
  50% {
    box-shadow: 0 0 0 12px rgba(44, 104, 161, 0);
    transform: scale(1.02);
  }
}

.learning-supports-autofill-pulse {
  animation: learning-supports-autofill-pulse 1.5s ease-in-out infinite;
}

.plan-doc-actions-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 24px;
  margin-top: 0;
  margin-bottom: 0;
  background: #f7f7f2;
  border: none;
  border-top: 1px solid #e0e0e0;
  border-radius: 0 0 12px 12px;
  box-sizing: border-box;
  width: 100%;
  clear: both;
}

.plan-doc-actions-inline {
  margin-bottom: 10px;
}

/* Message body sets width; download bar follows message width (does not expand it) */
.message-plan-doc-wrap {
  display: inline-block;
  max-width: 100%;
  vertical-align: top;
}

.message-plan-doc-wrap .message-inner-div,
.message-plan-doc-wrap .message-plan-doc-text {
  margin-bottom: 0;
  border-radius: 12px 12px 0 0;
}

.message-plan-doc-bar-sync .plan-doc-actions-bar {
  width: 100%;
  box-sizing: border-box;
  flex-wrap: wrap;
}

.message-plan-doc-bar-sync .plan-doc-actions-buttons {
  flex-wrap: wrap;
}

.afterchatbot .message-plan-doc-wrap .message-inner-div {
  padding-bottom: 15px;
}

.plan-doc-status {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex-shrink: 0;
}

.plan-doc-status-copy {
  width: 20px;
  height: 20px;
  cursor: pointer;
  display: block;
  flex-shrink: 0;
}

.given-container .message-content-inner .plan-doc-status-copy {
  display: block;
}

.plan-doc-status-text {
  font-weight: 600;
  color: #202124;
  font-size: 17px;
  line-height: 1.2;
  font-weight: 700;
}

.message-copy-wrap {
  margin-top: 8px;
  margin-bottom: 4px;
  clear: both;
}

.message-copy-btn {
  position: static !important;
  bottom: auto !important;
  left: auto !important;
  margin-top: 5px !important;
}

.afterchatbot .given-container .message-content-inner .message-copy-wrap .group-image {
  position: static !important;
  bottom: auto !important;
  left: auto !important;
  margin-top: 5px !important;
}

.plan-doc-actions-buttons {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-left: auto;
}

.plan-doc-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  text-decoration: none;
  line-height: 1.2;
  white-space: nowrap;
  font-family: inherit;
  box-sizing: border-box;
}

.plan-doc-btn-icon {
  flex-shrink: 0;
}

.plan-doc-btn-download {
  background: #000;
  color: #fff;
  font-weight: 600;
}

.plan-doc-btn-download:hover {
  background: #1a1a1a;
}

.plan-doc-btn-secondary {
  background: #fff;
  color: #202124;
  border: 1px solid #e0e0e0;
}

.plan-doc-btn-secondary:hover:not(:disabled) {
  background: #fafafa;
  border-color: #d0d0d0;
}

.plan-doc-btn-secondary:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

@media screen and (max-width: 640px) {
  .plan-doc-actions-bar {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding: 14px 16px;
    border-radius: 0 0 10px 10px;
  }

  .plan-doc-status {
    justify-content: flex-start;
  }

  .plan-doc-actions-buttons {
    width: 100%;
    margin-left: 0;
    justify-content: flex-start;
    gap: 8px;
  }

  .plan-doc-btn {
    flex: 1 1 auto;
    min-width: 0;
    padding: 10px 12px;
    font-size: 13px;
  }
}

.plan-doc-confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.plan-doc-confirm-box {
  background: #fff;
  padding: 24px;
  border-radius: 10px;
  max-width: 360px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.plan-doc-confirm-box p {
  margin: 0 0 20px;
  color: #333;
  font-size: 15px;
}

.plan-doc-confirm-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.plan-doc-btn-yes {
  background: #2c68a1;
  color: #fff;
}

.plan-doc-btn-no {
  background: #eee;
  color: #333;
}

.plan-doc-confirm-box-wide {
  max-width: 480px;
  width: 92vw;
  text-align: left;
}

.plan-doc-confirm-title {
  font-weight: 600;
  font-size: 16px !important;
  margin-bottom: 8px !important;
  text-align: center;
}

.plan-doc-confirm-hint,
.plan-doc-confirm-note {
  font-size: 13px !important;
  color: #555 !important;
  line-height: 1.45;
}

.plan-doc-folder-input {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  border: 1px solid #c5d4e3;
  border-radius: 8px;
  font-size: 14px;
  margin-bottom: 8px;
}

.plan-doc-folder-input:focus {
  outline: none;
  border-color: #2c68a1;
  box-shadow: 0 0 0 2px rgba(44, 104, 161, 0.15);
}

/* =====================================
   Home page sidebar layout (Homescsbc)
   Keeps questionnaire content clear of fixed sidebar
   ===================================== */

.home-page-content-inner #content.content {
  box-sizing: border-box;
  transition: margin-left 0.3s ease, width 0.3s ease;
  transform: none !important;
}

.home-page-content-inner #content.content.shrink {
  margin-left: 277px;
  width: calc(100% - 277px);
}

.home-page-content-inner #content.content:not(.shrink) {
  margin-left: 0;
  width: 100%;
}

/* =====================================
   After-chatbot sidebar layout (scoped)
   Fixes open/closed sidebar alignment
   ===================================== */

.afterchatbot .afterchatbot-layout.sidebar-content-other {
  display: flex;
  width: 100%;
  overflow: visible;
}

.afterchatbot .afterchatbot-layout > .sidebar-content-other {
  flex: 0 0;
  width: 0;
  min-width: 0;
  overflow: visible;
}

.afterchatbot .afterchatbot-layout > .home-page-content-inner {
  flex: 1 1;
  min-width: 0;
  width: auto;
  overflow: visible;
}

.afterchatbot .header-inner {
  flex-shrink: 0;
}

/* Keep overflow off #content so .inner-images-content sticky works */
.afterchatbot .home-page-content-inner #content.content {
  overflow: visible;
}

.afterchatbot .home-page-content-inner #content .output-outer-content {
  overflow-x: hidden;
}

.afterchatbot .home-page-content-inner {
  min-height: 0;
}

.afterchatbot #content.content {
  box-sizing: border-box;
  transition: margin-left 0.3s ease, width 0.3s ease;
  transform: none !important;
}

.afterchatbot #content.content.shrink {
  margin-left: 277px;
  width: calc(100% - 277px);
}

.afterchatbot #content.content:not(.shrink) {
  margin-left: 0;
  width: 100%;
}

.afterchatbot #content .output-container.output-tft {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: 0 25px;
}

.afterchatbot #content:not(.shrink) .output-outer-content,
.afterchatbot #content:not(.shrink) .chatbox-conent-inner,
.afterchatbot #content:not(.shrink) .chatbox {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.afterchatbot #content:not(.shrink) .inner-images-content {
  position: sticky;
  bottom: 0;
  z-index: 100;
  width: 100%;
  box-sizing: border-box;
  padding: 15px 25px;
}

.afterchatbot #content:not(.shrink) .field-input-inn {
  width: 100%;
  max-width: 100%;
}

.afterchatbot #content.shrink .inner-images-content {
  position: sticky;
  bottom: 0;
  z-index: 100;
  width: 100%;
  box-sizing: border-box;
  padding: 15px 25px;
}

/* Tablet & mobile: chat input container (afterchatbot only) */
@media screen and (max-width: 1200px) {
  .afterchatbot #content .field-input-inn.input-field-btn {
    position: relative !important;
    width: 100% !important;
    bottom: auto !important;
    display: flex;
    align-items: flex-end;
    gap: 12px;
    box-sizing: border-box;
  }

  .afterchatbot #content .field-input-inn .outer-textare-inn {
    flex: 1 1 auto;
    min-width: 0;
    position: relative;
  }

  .afterchatbot #content .field-input-inn textarea.input-field {
    width: 100% !important;
    max-width: 100% !important;
    min-height: 60px;
    padding: 10px 42px 10px 16px !important;
    box-sizing: border-box;
    resize: none;
  }

  .afterchatbot #content .field-input-inn .translate-inn {
    position: absolute !important;
    right: 10px !important;
    bottom: 10px !important;
    left: auto !important;
    top: auto !important;
    transform: none !important;
    padding: 2px 4px !important;
    margin: 0 !important;
  }

  .afterchatbot #content .field-input-inn .file-ref-inner {
    position: static;
    top: auto;
    flex: 0 0 auto;
    display: flex;
    align-items: flex-end;
  }

  .afterchatbot #content .field-input-inn .submit-btn,
  .afterchatbot #content .field-input-inn button.submit-btn {
    position: static !important;
    right: auto !important;
    bottom: auto !important;
    width: auto !important;
    min-width: 72px;
    height: auto !important;
    min-height: 38px;
    padding: 8px 16px !important;
    margin: 0;
    flex-shrink: 0;
    white-space: nowrap;
  }
}

@media screen and (max-width: 991px) {
  .afterchatbot #content .output-container.output-tft {
    padding: 0 20px;
  }

  .afterchatbot #content:not(.shrink) .inner-images-content,
  .afterchatbot #content.shrink .inner-images-content {
    padding: 12px 20px;
  }

  .afterchatbot #content .field-input-inn.input-field-btn {
    gap: 10px;
  }

  .afterchatbot #content .field-input-inn textarea.input-field {
    min-height: 56px;
    font-size: 14px;
    padding: 10px 40px 10px 14px !important;
  }
}

@media screen and (max-width: 768px) {
  .afterchatbot #content .field-input-inn.input-field-btn {
    gap: 8px;
  }

  .afterchatbot #content .field-input-inn .submit-btn,
  .afterchatbot #content .field-input-inn button.submit-btn {
    min-width: 68px;
    min-height: 36px;
    padding: 7px 12px !important;
    font-size: 13px;
  }

  .afterchatbot #content .field-input-inn .translate-inn svg {
    font-size: 22px !important;
  }
}

@media only screen and (max-width: 480px) {
  .afterchatbot #content.content.shrink {
    margin-left: 0;
    width: 100%;
  }

  .afterchatbot #content .output-container.output-tft {
    padding: 0 16px;
  }

  .afterchatbot #content:not(.shrink) .inner-images-content,
  .afterchatbot #content.shrink .inner-images-content {
    padding: 10px 16px;
  }

  .afterchatbot #content .field-input-inn.input-field-btn {
    gap: 8px;
    margin-bottom: 8px;
  }

  .afterchatbot #content .field-input-inn textarea.input-field {
    min-height: 52px;
    font-size: 13px;
    padding: 10px 36px 10px 12px !important;
  }

  .afterchatbot #content .field-input-inn .translate-inn {
    right: 8px !important;
    bottom: 8px !important;
  }

  .afterchatbot #content .field-input-inn .submit-btn,
  .afterchatbot #content .field-input-inn button.submit-btn {
    min-width: 64px;
    min-height: 34px;
    padding: 6px 10px !important;
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home/homestyle.css"],"names":[],"mappings":";;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,UAAU;AACd;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;;;;;GAKG;;AAEH;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,aAAa,EAAE,gBAAgB;EACjC;;EAEA;IACE,SAAS;IACT,yBAAyB,EAAE,qCAAqC;EAClE;;EAEA;IACE,UAAU;IACV,sBAAsB,EAAE,aAAa;EACvC;AACF;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;;AAEtB;AACA;IACI,uBAAuB;AAC3B;AACA;;;GAGG;;AAEH;AACA,wJAAwJ;AACxJ,gBAAgB;AAChB,eAAe;;AAEf;AACA;AACA,wJAAwJ;;AAExJ,gBAAgB;AAChB,eAAe;AACf,mBAAmB;AACnB;;AAEA;;;;GAIG;;AAEH;EACE,wJAAwJ;EACxJ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,iBAAiB,EAAE,qDAAqD;AAC1E;;AAEA;;;;GAIG;AACH;IACI,iBAAiB;AACrB;AACA;IACI,2BAA2B;AAC/B;AACA;;IAEI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB;;;qCAGmC;EACnC,0BAA0B,EAAE,yBAAyB;;AAEvD;AACA,2GAA2G;;AAE3G,6CAA6C;AAC7C;EACE,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,gDAAgD;EAChD,6BAA6B;AAC/B;;AAEA,qCAAqC;AACrC;CACC,2DAA2D;EAC1D,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;AACzB;;AAEA,oDAAoD;AACpD;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4EAA4E;AAC5E;EACE;IACE,2CAA2C;IAC3C,mBAAmB;EACrB;EACA;IACE,4CAA4C;IAC5C,sBAAsB;EACxB;AACF;;AAEA;EACE,qEAAqE;AACvE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,4BAA4B;EAC5B,sBAAsB;EACtB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qFAAqF;AACrF;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,cAAc;IACd,2BAA2B;IAC3B,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;;EAEE,0BAA0B;EAC1B,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;;0CAG0C;;AAE1C;EACE,sBAAsB;EACtB,kDAAkD;EAClD,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;;;0CAG0C;;AAE1C;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,SAAW;EACX,QAAQ;EACR,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,qEAAqE;AACrE;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,kDAAkD;EAClD,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;;EAGE,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,8DAA8D;AAC9D;EACE;IACE,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,gBAAgB;IAChB,uCAAuC;IACvC,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,oBAAoB;IACpB,0BAA0B;IAC1B,2BAA2B;IAC3B,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,aAAa;IACb,qBAAqB;EACvB;;EAEA;;IAEE,2BAA2B;IAC3B,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,4BAA4B;IAC5B,SAAS;IACT,cAAc;IACd,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;;IAEE,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,uCAAuC;EACzC;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;;IAEE,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;EACjB;AACF","sourcesContent":["  \n\n.chat-container {\n    max-width: 600px;\n    margin: auto;\n    padding: 20px;\n    text-align: center;\n}\n\n.chatbox {\n    height: 500px;\n    overflow-y: auto;\n    padding: 10px;\n    width: 80%;\n}\n.chatbox-conent-inner{\n    display: flex;\n    justify-content: center;\n}\n/* \n.message {\n    padding: 10px;\n    border-radius: 8px;\n    margin: 5px 0;\n} */\n\n.user {\n    /* background: #d1e7ff; */\n    text-align: right;\n}\n\n.bot {\n    /* background: #e5e5e5; */\n    text-align: left;\n}\n\n.chat-input {\n    display: flex;\n    gap: 10px;\n    margin-top: 10px;\n}\n\n.chat-input input {\n    flex: 1;\n    padding: 10px;\n}\n\n.chat-input button {\n    padding: 10px 15px;\n    background: blue;\n    color: white;\n    border: none;\n}\n\n.container {\n    display: flex;\n    height: 100vh; /* Full height */\n  }\n  \n  .sidebar {\n    width: 0%;\n    background-color: #f4f4f4; /* Optional: Add a background color */\n  }\n  \n  .chatbot {\n    width: 70%;\n    background-color: #fff; /* Optional */\n  }\n.home-inner-page .chatbox-conent-inner .chatbox {\n    width: 100%;\n    height: auto;\n    overflow-y: hidden;\n\n}\ndiv.css-m39tm9 {\n    background-color: unset;\n}\n/* .question-inner-part{\nfont-weight: 500;\nfont-size: 15px;\n} */\n\n.question-inner-part{\nfont-family: ui-sans-serif, -apple-system, system-ui, \"Segoe UI\", Helvetica, \"Apple Color Emoji\", Arial, sans-serif, \"Segoe UI Emoji\", \"Segoe UI Symbol\";\nfont-weight: 500;\nfont-size: 17px;\n\n}\n.answer-inner-part{\nfont-family: ui-sans-serif, -apple-system, system-ui, \"Segoe UI\", Helvetica, \"Apple Color Emoji\", Arial, sans-serif, \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n\nfont-weight: 400;\nfont-size: 17px;\nmargin-bottom: 10px;\n}\n\n/* .message-inner{\n  font-weight: 400;\n  font-size: 15px;\n\n} */\n\n.message-inner {\n  font-family: ui-sans-serif, -apple-system, system-ui, \"Segoe UI\", Helvetica, \"Apple Color Emoji\", Arial, sans-serif, \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 17px;\n  color: rgb(13, 13, 13);\n  line-height: 30px; /* Equal to 1.75 * font-size — good for readability */\n}\n\n/* .answer-inner-part{\nfont-weight: 400;\nfont-size: 15px;\nmargin-bottom: 10px;\n} */\n.group-image{\n    margin-top: -25px;\n}\n.contents.full-unit:hover{\n    background-color: LightGrey;\n}\n.generate-inner,\n.contents.full-unit{\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 400;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    line-height: 19px;\n}\n.sidebar-settings-icon {\n    width: 18px;\n    height: 18px;\n    color: #2C68A1;\n}\n.spinner-box {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 10px;\n  flex-flow: column; \n  /* position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%); */\n  height:calc(100vh - 250px); /* full viewport height */\n\n}\n/* ===================================== New CSS for Chat Interface ===================================== */\n\n/* Fixed Bottom Section - Button won't move */\n.inner-images-content {\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: white;\n  z-index: 100;\n  padding: 15px 0px;\n  /* box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); */\n  border-top: 1px solid #e0e0e0;\n}\n\n/* Chat Container - Scrollable area */\n.output-outer-content {\n /* padding-bottom: 220px;  Space for fixed bottom section */\n  overflow-y: auto;\n  /* max-height: calc(100vh - 250px); */\n}\n\n.chatbox {\n  padding-bottom: 20px;\n}\n\n/* Input Field Container */\n.input-field-btn {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.input-field {\n  flex: 1;\n  padding: 10px 15px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-size: 14px;\n  resize: none;\n  outline: none;\n  font-family: inherit;\n}\n\n.input-field:focus {\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);\n}\n\n.submit-btn {\n  padding: 10px 20px;\n  background: #007bff;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  white-space: nowrap;\n  flex-shrink: 0;\n  transition: background 0.2s;\n}\n\n.submit-btn:hover {\n  background: #0056b3;\n}\n\n.submit-btn:active {\n  transform: scale(0.98);\n}\n\n.submit-btn img {\n  width: 16px;\n  height: 16px;\n}\n\n/* Bottom Buttons Container */\n.buttons-cont-flex {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  justify-content: left;\n}\n\n.buttons-cont-flex button {\n  padding: 8px 16px;\n  border: 1px solid #ddd;\n  background: white;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n  font-size: 14px;\n}\n\n.buttons-cont-flex button:hover {\n  background: #f5f5f5;\n  border-color: #007bff;\n  transform: translateY(-1px);\n}\n\n.high-light-btn {\n  background: #007bff !important;\n  color: white !important;\n  border-color: #007bff !important;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .inner-images-content {\n    padding: 10px;\n  }\n  \n  .output-outer-content {\n    padding-bottom:25px;\n  }\n  \n  .buttons-cont-flex {\n    gap: 5px;\n  }\n  \n  .buttons-cont-flex button {\n    padding: 6px 12px;\n    font-size: 12px;\n  }\n  \n  .submit-btn {\n    padding: 8px 16px;\n  }\n}\n\n/* Smooth Scrolling */\n.output-outer-content {\n  scroll-behavior: smooth;\n}\n\n/* Optional: Hide scrollbar but keep functionality */\n.output-outer-content::-webkit-scrollbar {\n  width: 8px;\n}\n\n.output-outer-content::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.output-outer-content::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 4px;\n}\n\n.output-outer-content::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/* Learning Supports: Autofill button pulse animation (theme blue #2c68a1) */\n@keyframes learning-supports-autofill-pulse {\n  0%, 100% {\n    box-shadow: 0 0 0 0 rgba(44, 104, 161, 0.5);\n    transform: scale(1);\n  }\n  50% {\n    box-shadow: 0 0 0 12px rgba(44, 104, 161, 0);\n    transform: scale(1.02);\n  }\n}\n\n.learning-supports-autofill-pulse {\n  animation: learning-supports-autofill-pulse 1.5s ease-in-out infinite;\n}\n\n.plan-doc-actions-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 20px 24px;\n  margin-top: 0;\n  margin-bottom: 0;\n  background: #f7f7f2;\n  border: none;\n  border-top: 1px solid #e0e0e0;\n  border-radius: 0 0 12px 12px;\n  box-sizing: border-box;\n  width: 100%;\n  clear: both;\n}\n\n.plan-doc-actions-inline {\n  margin-bottom: 10px;\n}\n\n/* Message body sets width; download bar follows message width (does not expand it) */\n.message-plan-doc-wrap {\n  display: inline-block;\n  max-width: 100%;\n  vertical-align: top;\n}\n\n.message-plan-doc-wrap .message-inner-div,\n.message-plan-doc-wrap .message-plan-doc-text {\n  margin-bottom: 0;\n  border-radius: 12px 12px 0 0;\n}\n\n.message-plan-doc-bar-sync .plan-doc-actions-bar {\n  width: 100%;\n  box-sizing: border-box;\n  flex-wrap: wrap;\n}\n\n.message-plan-doc-bar-sync .plan-doc-actions-buttons {\n  flex-wrap: wrap;\n}\n\n.afterchatbot .message-plan-doc-wrap .message-inner-div {\n  padding-bottom: 15px;\n}\n\n.plan-doc-status {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  flex-shrink: 0;\n}\n\n.plan-doc-status-copy {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  display: block;\n  flex-shrink: 0;\n}\n\n.given-container .message-content-inner .plan-doc-status-copy {\n  display: block;\n}\n\n.plan-doc-status-text {\n  font-weight: 600;\n  color: #202124;\n  font-size: 17px;\n  line-height: 1.2;\n  font-weight: 700;\n}\n\n.message-copy-wrap {\n  margin-top: 8px;\n  margin-bottom: 4px;\n  clear: both;\n}\n\n.message-copy-btn {\n  position: static !important;\n  bottom: auto !important;\n  left: auto !important;\n  margin-top: 5px !important;\n}\n\n.afterchatbot .given-container .message-content-inner .message-copy-wrap .group-image {\n  position: static !important;\n  bottom: auto !important;\n  left: auto !important;\n  margin-top: 5px !important;\n}\n\n.plan-doc-actions-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-left: auto;\n}\n\n.plan-doc-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  border: none;\n  text-decoration: none;\n  line-height: 1.2;\n  white-space: nowrap;\n  font-family: inherit;\n  box-sizing: border-box;\n}\n\n.plan-doc-btn-icon {\n  flex-shrink: 0;\n}\n\n.plan-doc-btn-download {\n  background: #000;\n  color: #fff;\n  font-weight: 600;\n}\n\n.plan-doc-btn-download:hover {\n  background: #1a1a1a;\n}\n\n.plan-doc-btn-secondary {\n  background: #fff;\n  color: #202124;\n  border: 1px solid #e0e0e0;\n}\n\n.plan-doc-btn-secondary:hover:not(:disabled) {\n  background: #fafafa;\n  border-color: #d0d0d0;\n}\n\n.plan-doc-btn-secondary:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n@media screen and (max-width: 640px) {\n  .plan-doc-actions-bar {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n    padding: 14px 16px;\n    border-radius: 0 0 10px 10px;\n  }\n\n  .plan-doc-status {\n    justify-content: flex-start;\n  }\n\n  .plan-doc-actions-buttons {\n    width: 100%;\n    margin-left: 0;\n    justify-content: flex-start;\n    gap: 8px;\n  }\n\n  .plan-doc-btn {\n    flex: 1 1 auto;\n    min-width: 0;\n    padding: 10px 12px;\n    font-size: 13px;\n  }\n}\n\n.plan-doc-confirm-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.plan-doc-confirm-box {\n  background: #fff;\n  padding: 24px;\n  border-radius: 10px;\n  max-width: 360px;\n  text-align: center;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n.plan-doc-confirm-box p {\n  margin: 0 0 20px;\n  color: #333;\n  font-size: 15px;\n}\n\n.plan-doc-confirm-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n}\n\n.plan-doc-btn-yes {\n  background: #2c68a1;\n  color: #fff;\n}\n\n.plan-doc-btn-no {\n  background: #eee;\n  color: #333;\n}\n\n.plan-doc-confirm-box-wide {\n  max-width: 480px;\n  width: 92vw;\n  text-align: left;\n}\n\n.plan-doc-confirm-title {\n  font-weight: 600;\n  font-size: 16px !important;\n  margin-bottom: 8px !important;\n  text-align: center;\n}\n\n.plan-doc-confirm-hint,\n.plan-doc-confirm-note {\n  font-size: 13px !important;\n  color: #555 !important;\n  line-height: 1.45;\n}\n\n.plan-doc-folder-input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 10px 12px;\n  border: 1px solid #c5d4e3;\n  border-radius: 8px;\n  font-size: 14px;\n  margin-bottom: 8px;\n}\n\n.plan-doc-folder-input:focus {\n  outline: none;\n  border-color: #2c68a1;\n  box-shadow: 0 0 0 2px rgba(44, 104, 161, 0.15);\n}\n\n/* =====================================\n   Home page sidebar layout (Homescsbc)\n   Keeps questionnaire content clear of fixed sidebar\n   ===================================== */\n\n.home-page-content-inner #content.content {\n  box-sizing: border-box;\n  transition: margin-left 0.3s ease, width 0.3s ease;\n  transform: none !important;\n}\n\n.home-page-content-inner #content.content.shrink {\n  margin-left: 277px;\n  width: calc(100% - 277px);\n}\n\n.home-page-content-inner #content.content:not(.shrink) {\n  margin-left: 0;\n  width: 100%;\n}\n\n/* =====================================\n   After-chatbot sidebar layout (scoped)\n   Fixes open/closed sidebar alignment\n   ===================================== */\n\n.afterchatbot .afterchatbot-layout.sidebar-content-other {\n  display: flex;\n  width: 100%;\n  overflow: visible;\n}\n\n.afterchatbot .afterchatbot-layout > .sidebar-content-other {\n  flex: 0 0 0;\n  width: 0;\n  min-width: 0;\n  overflow: visible;\n}\n\n.afterchatbot .afterchatbot-layout > .home-page-content-inner {\n  flex: 1 1 0;\n  min-width: 0;\n  width: auto;\n  overflow: visible;\n}\n\n.afterchatbot .header-inner {\n  flex-shrink: 0;\n}\n\n/* Keep overflow off #content so .inner-images-content sticky works */\n.afterchatbot .home-page-content-inner #content.content {\n  overflow: visible;\n}\n\n.afterchatbot .home-page-content-inner #content .output-outer-content {\n  overflow-x: hidden;\n}\n\n.afterchatbot .home-page-content-inner {\n  min-height: 0;\n}\n\n.afterchatbot #content.content {\n  box-sizing: border-box;\n  transition: margin-left 0.3s ease, width 0.3s ease;\n  transform: none !important;\n}\n\n.afterchatbot #content.content.shrink {\n  margin-left: 277px;\n  width: calc(100% - 277px);\n}\n\n.afterchatbot #content.content:not(.shrink) {\n  margin-left: 0;\n  width: 100%;\n}\n\n.afterchatbot #content .output-container.output-tft {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  padding: 0 25px;\n}\n\n.afterchatbot #content:not(.shrink) .output-outer-content,\n.afterchatbot #content:not(.shrink) .chatbox-conent-inner,\n.afterchatbot #content:not(.shrink) .chatbox {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.afterchatbot #content:not(.shrink) .inner-images-content {\n  position: sticky;\n  bottom: 0;\n  z-index: 100;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 15px 25px;\n}\n\n.afterchatbot #content:not(.shrink) .field-input-inn {\n  width: 100%;\n  max-width: 100%;\n}\n\n.afterchatbot #content.shrink .inner-images-content {\n  position: sticky;\n  bottom: 0;\n  z-index: 100;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 15px 25px;\n}\n\n/* Tablet & mobile: chat input container (afterchatbot only) */\n@media screen and (max-width: 1200px) {\n  .afterchatbot #content .field-input-inn.input-field-btn {\n    position: relative !important;\n    width: 100% !important;\n    bottom: auto !important;\n    display: flex;\n    align-items: flex-end;\n    gap: 12px;\n    box-sizing: border-box;\n  }\n\n  .afterchatbot #content .field-input-inn .outer-textare-inn {\n    flex: 1 1 auto;\n    min-width: 0;\n    position: relative;\n  }\n\n  .afterchatbot #content .field-input-inn textarea.input-field {\n    width: 100% !important;\n    max-width: 100% !important;\n    min-height: 60px;\n    padding: 10px 42px 10px 16px !important;\n    box-sizing: border-box;\n    resize: none;\n  }\n\n  .afterchatbot #content .field-input-inn .translate-inn {\n    position: absolute !important;\n    right: 10px !important;\n    bottom: 10px !important;\n    left: auto !important;\n    top: auto !important;\n    transform: none !important;\n    padding: 2px 4px !important;\n    margin: 0 !important;\n  }\n\n  .afterchatbot #content .field-input-inn .file-ref-inner {\n    position: static;\n    top: auto;\n    flex: 0 0 auto;\n    display: flex;\n    align-items: flex-end;\n  }\n\n  .afterchatbot #content .field-input-inn .submit-btn,\n  .afterchatbot #content .field-input-inn button.submit-btn {\n    position: static !important;\n    right: auto !important;\n    bottom: auto !important;\n    width: auto !important;\n    min-width: 72px;\n    height: auto !important;\n    min-height: 38px;\n    padding: 8px 16px !important;\n    margin: 0;\n    flex-shrink: 0;\n    white-space: nowrap;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .afterchatbot #content .output-container.output-tft {\n    padding: 0 20px;\n  }\n\n  .afterchatbot #content:not(.shrink) .inner-images-content,\n  .afterchatbot #content.shrink .inner-images-content {\n    padding: 12px 20px;\n  }\n\n  .afterchatbot #content .field-input-inn.input-field-btn {\n    gap: 10px;\n  }\n\n  .afterchatbot #content .field-input-inn textarea.input-field {\n    min-height: 56px;\n    font-size: 14px;\n    padding: 10px 40px 10px 14px !important;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .afterchatbot #content .field-input-inn.input-field-btn {\n    gap: 8px;\n  }\n\n  .afterchatbot #content .field-input-inn .submit-btn,\n  .afterchatbot #content .field-input-inn button.submit-btn {\n    min-width: 68px;\n    min-height: 36px;\n    padding: 7px 12px !important;\n    font-size: 13px;\n  }\n\n  .afterchatbot #content .field-input-inn .translate-inn svg {\n    font-size: 22px !important;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .afterchatbot #content.content.shrink {\n    margin-left: 0;\n    width: 100%;\n  }\n\n  .afterchatbot #content .output-container.output-tft {\n    padding: 0 16px;\n  }\n\n  .afterchatbot #content:not(.shrink) .inner-images-content,\n  .afterchatbot #content.shrink .inner-images-content {\n    padding: 10px 16px;\n  }\n\n  .afterchatbot #content .field-input-inn.input-field-btn {\n    gap: 8px;\n    margin-bottom: 8px;\n  }\n\n  .afterchatbot #content .field-input-inn textarea.input-field {\n    min-height: 52px;\n    font-size: 13px;\n    padding: 10px 36px 10px 12px !important;\n  }\n\n  .afterchatbot #content .field-input-inn .translate-inn {\n    right: 8px !important;\n    bottom: 8px !important;\n  }\n\n  .afterchatbot #content .field-input-inn .submit-btn,\n  .afterchatbot #content .field-input-inn button.submit-btn {\n    min-width: 64px;\n    min-height: 34px;\n    padding: 6px 10px !important;\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
